import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Database, LineChart, Lightbulb, Smartphone } from 'lucide-react';
export function SolutionFlow() {
  const steps = [{
    icon: Smartphone,
    title: 'Connect Google Fit',
    description: 'Link your existing health data securely in seconds.'
  }, {
    icon: Database,
    title: 'Establish Baseline',
    description: 'We analyze your history to understand YOUR normal.'
  }, {
    icon: LineChart,
    title: 'Compare Recent Data',
    description: 'We spot deviations and trends as they happen.'
  }, {
    icon: Lightbulb,
    title: 'Generate Insights',
    description: 'Get clear, actionable advice in plain English.'
  }];
  return <section className="py-24 bg-slate-900 text-white overflow-hidden" data-id="element-137">
      <div className="container mx-auto px-4" data-id="element-138">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-140">
            From raw data to clarity
          </h2>
          <p className="text-lg text-slate-400" data-id="element-141">
            Vytaniq does the heavy lifting so you don't have to be a data
            scientist to understand your body.
          </p>
        </div>

        <div className="relative" data-id="element-142">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-slate-800" data-id="element-143" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10" data-id="element-144">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.5
          }} className="relative flex flex-col items-center text-center" data-id="element-145">
                {/* Step Number/Icon Container */}
                <div className="relative mb-6" data-id="element-146">
                  <div className="h-24 w-24 rounded-full bg-slate-800 border-4 border-slate-900 flex items-center justify-center z-10 relative group hover:bg-teal-900/30 transition-colors duration-300" data-id="element-147">
                    <step.icon className="h-10 w-10 text-teal-500" data-id="element-148" />
                  </div>
                  {/* Connector for mobile */}
                  {index < steps.length - 1 && <div className="md:hidden absolute top-24 left-1/2 w-0.5 h-12 bg-slate-800 -translate-x-1/2" data-id="element-149" />}
                </div>

                <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-150">
                  {step.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed max-w-[200px]" data-id="element-151">
                  {step.description}
                </p>

                {/* Arrow for desktop flow */}
                {index < steps.length - 1 && <div className="hidden md:block absolute top-10 -right-[20%] text-slate-700" data-id="element-152">
                    <ArrowRight className="h-6 w-6" data-id="element-153" />
                  </div>}
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}